module.exports = __webpack_public_path__ + "castorama.png?5513ad2ccbedb0f09e93e5060cef7dc3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/castorama.png
// module id = 953
// module chunks = 2